import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { graceSubscriptionSidebarDetail } from 'reactApp/appHelpers/featuresHelpers/features/graceSubscriptions';
import { abPauseSubscription } from 'reactApp/appHelpers/featuresHelpers/features/pauseSubscription';
import { type BillingDataSubscriptionInfo, isTBankSubscription } from 'reactApp/modules/billingData/billingData.types';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { getPausedSubscriptionStorageKey, isPausedSubscription } from 'reactApp/modules/subscriptions/subscriptions.helpers';
import { UserStorageSelectors } from 'reactApp/modules/user/userStorage';
import { isGraceSubscription } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.helpers';
import type { RootState } from 'reactApp/store';
import { TitleVariants } from 'reactApp/ui/Subscriptions/Subscriptions.utils';
import { createGaSender } from 'reactApp/utils/ga';

import { SubscriptionItem } from '../SubscriptionListItem/SubscriptionListItem';
import { composeContent } from './ModernSubscriptionItem.helpers';

const sendGa = createGaSender('subs-sidebar');

type Props = {
    subscription: BillingDataSubscriptionInfo;
    onClick: () => void;
    isRebranding?: boolean;
    isRebrandingQuotaLanding?: boolean;
};

export const ModernSubscriptionItemComponent = memo<Props>(({ subscription, onClick, isRebranding = false, isRebrandingQuotaLanding }) => {
    const { productId, type } = subscription;
    const isGrace = isGraceSubscription(subscription);
    const product = useSelector((state: RootState) => ProductsSelectors.getProductById(state, productId));
    const pausedSubscription: boolean =
        useSelector((state: RootState) => UserStorageSelectors.get(state, getPausedSubscriptionStorageKey(subscription.id))) &&
        isPausedSubscription(abPauseSubscription, subscription.renewAt);
    const { title, description, icon, partner, showWaiting } = composeContent({ subscription, product, pausedSubscription });

    const handleOnClick = () => {
        // нельзя слать полный id продукта, потому что тогда не укладываемся в лимит на длину метрики
        sendGa('click', 'subs-item', `${type}${productId ? `_${productId.slice(0, 16)}` : ''}`);

        onClick();
    };
    const titleVariant = isGrace ? TitleVariants.ERROR : undefined;
    const errorDescription = graceSubscriptionSidebarDetail && isGrace ? 'Ваша подписка закончилась' : undefined;
    return (
        <SubscriptionItem
            type={isTBankSubscription(subscription) ? 'tbank' : partner}
            showWaiting={showWaiting}
            icon={icon}
            title={title}
            titleVariant={titleVariant}
            description={description}
            errorDescription={errorDescription}
            onClick={handleOnClick}
            isRebranding={isRebranding}
            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
        />
    );
});

ModernSubscriptionItemComponent.displayName = 'ModernSubscriptionItemComponent';
